<template>
  <div class="page-content mt-3">
    <div class="container-fluid">
      <div class="card" id="orderList">
        <div class="row mt-4 mx-4">
          <div class="col">
            <h3 class="fw-bold">Referral Metrics</h3>
            <p class="text-muted small">Summary</p>
          </div>
          <div class="col text-center">
            <h4 class="fw-bold">User No: {{ this.user.userNo }}</h4>
          </div>

          <div
            class="col text-center"
            style="
              background-color: #d4edda;
              color: #155724;
              border-radius: 0.5rem;
              width: 100px;
            "
          >
            <span
              class="d-inline-flex align-items-center justify-content-center px-3 py-2 fw-bold "
            >
              <i class="ri-wallet-3-fill me-2"></i>
              Wallet Balance
            </span>
            <br>
            <span>{{ user.walletBalance }}</span>
          </div>

          <!-- <div class="col">
            <button class="btn btn-success">View User Details</button>
          </div> -->
        </div>

        <div class="row mt-4 mb-4 g-3 justify-content-center">
          <div
            class="col-6 col-md-2"
            v-for="metric in metrics"
            :key="metric.label"
          >
            <div
              class="card text-center h-100 border-0 shadow-sm text-white"
              :style="{ background: metric.gradient }"
            >
              <div class="card-body">
                <i :class="metric.icon" style="font-size: 24px"></i>
                <h3 class="fw-bold mt-2">{{ metric.value }}</h3>
                <p class="mb-0">{{ metric.label }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="card p-4 my-4">
        <div class="d-flex justify-content-end mb-3">
          <button type="button" class="btn btn-info" @click="exportCSV()">
            <i class="ri-download-line align-bottom me-1"></i> Export
          </button>
        </div>
        <div class="d-flex justify-content-between align-items-center mb-3">
          <h4 class="fw-bold">Referee Table</h4>
          <div class="input-group" style="max-width: 300px">
            <input
              type="text"
              class="form-control"
              placeholder="Enter Contact No"
              v-model="searchQuery"
            />
            <button class="btn btn-outline-secondary" type="button">
              <i class="ri-search-line"></i>
            </button>
          </div>
        </div>

        <div class="card-body pt-0">
          <div class="mt-5">
            <div class="table-responsive table-card mb-1">
              <div class="noresult" v-if="noData">
                <Loadingtable />
              </div>
              <div v-else>
                <rb-data-table
                  :ldata="ldata"
                  :headers="headers"
                  :tableData="formattedrefees"
                  @edit="editUser"
                  @delete="openDeleteDialog"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "pinia";
import { useAuthStore } from "@/store/auth";

export default {
  name: "viewRefferal",

  data() {
    return {
      user: {
        userNo: "",
        walletBalance: "",
      },

      metrics: [
        {
          label: "Total Referrals",
          value: 24,
          icon: "bi bi-people-fill",
          gradient: "linear-gradient(135deg, #ff9a9e, #fad0c4)",
        },
        {
          label: "Success Referrals",
          value: 22,
          icon: "bi bi-check-circle-fill",
          gradient: "linear-gradient(135deg, #f6d365, #fda085)",
        },
        {
          label: "Rewards Earned",
          value: "₹ 2200",
          icon: "bi bi-cash",
          gradient: "linear-gradient(135deg, #84fab0, #8fd3f4)",
        },
        {
          label: "Dormant Referrals",
          value: 5,
          icon: "bi bi-x-circle-fill",
          gradient: "linear-gradient(135deg, #a18cd1, #fbc2eb)",
        },
        {
          label: "Total Revenue",
          value: "₹ 5000",
          icon: "bi bi-currency-rupee",
          gradient: "linear-gradient(135deg, #f093fb, #f5576c)",
        },
      ],

      headers: [
        {
          name: "Referee",
        },
        {
          name: "Signup Date",
        },
        {
          name: "Type",
        },
        {
          name: "Bookings",
        },
        {
          name: "Revenue",
        },
        {
          name: "Referral Bonus",
        },
        {
          name: "Status",
          auth: true,
        },
        {
          name: "Actions",
          auth: true,
        },
      ],

      refees: [],
    };
  },

  methods: {
    exportCSV() {
      if (!this.formattedrefees.length) {
        alert("No data available to export.");
        return;
      }

      // Pick only the fields you want (exclude id & spec_id)
      const data = this.formattedrefees.map((refee) => ({
        mobile: refee.mobile,
        created_at: refee.created_at,
        type: refee.type,
        booking: refee.booking,
        revenue: refee.revenue,
        refferalBonus: refee.refferalBonus,
        status: refee.status,
      }));

      // Extract headers
      const headers = Object.keys(data[0]);

      // Convert to CSV
      const csvRows = [];
      csvRows.push(headers.join(",")); // header row
      data.forEach((row) => {
        const values = headers.map((header) => `"${row[header]}"`);
        csvRows.push(values.join(","));
      });

      const csvContent = csvRows.join("\n");

      // Download CSV
      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      const link = document.createElement("a");
      const url = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      link.setAttribute("download", "referrals.csv");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
  },

  mounted() {
    const viewRefferal = JSON.parse(localStorage.getItem("user_edit_data"));

    this.metrics[0].value = viewRefferal.total_referrals;
    this.metrics[1].value = viewRefferal.success_referrals;
    this.metrics[2].value = viewRefferal.rewardEarned;
    this.metrics[3].value = viewRefferal.referrals_count;
    this.metrics[4].value = viewRefferal.total_revenue;

    if (viewRefferal) {
      this.user.walletBalance = viewRefferal.wallet_balance;
      this.user.userNo = viewRefferal.referral_code;

      this.refees = viewRefferal.refees;
    }
  },

  computed: {
    ...mapState(useAuthStore, ["ldata"]),
    formattedrefees() {
      return this.refees.map((refee) => ({
        id: refee.id,

        spec_id: refee.customer_id,
        mobile: refee.phone_number || "N/A",

        created_at: refee.created_at
          ? new Date(refee.created_at).toLocaleString()
          : "N/A",
        type: refee.user_type || "N/A",

        booking: refee.total_success_bookings || "0",
        revenue: refee.total_revenue || "0",
        refferalBonus: refee.referral_bonus || "0",
        status: refee.is_active ? "credited" : "rejected",
      }));
    },
  },
};
</script>
